import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.states';
import { CoalService } from './coal.service';
import { OcultarSpinner } from 'app/store/actions/utils.action';

@Injectable()
export class StripeService {

    constructor(private coalService : CoalService,private readonly store: Store<AppState>) {}

    ChargeStripe(token,amount,currency,descripcion): PromiseLike<{}>{
        return new Promise((resolve, reject) => {
            let body = {
                token: token,
                amount: amount,
                currency: currency,
                descripcion: descripcion
            };
            this.coalService.postServicePayments('Stripe/PostChargeStripe', body).subscribe(
                (data: any) => {
                    this.store.dispatch(OcultarSpinner());
                    resolve(data);
                }, (error: any) => {
                    reject(error);
                });
        });
    }

    RefoundStripe(token){
        let body = {
            toke : token
        }
        this.coalService.postServicePayments('Stripe/PostRefundStripe',body).subscribe(
        (data: any) => {
            this.store.dispatch(OcultarSpinner());
            return data;
        }, (error: any) => {
            console.log("Error");
            console.log(error);
        });
    }

    RetriveStripe(body){
        this.coalService.postServicePayments('Stripe/PostRetrieveStripe',body).subscribe(
        (data: any) => {

            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("Error");
            console.log(error);
        });
    }
}
